import { render, staticRenderFns } from "./PlanAdvertisement.vue?vue&type=template&id=6cbc2262"
import script from "./PlanAdvertisement.vue?vue&type=script&lang=js"
export * from "./PlanAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./PlanAdvertisement.vue?vue&type=style&index=0&id=6cbc2262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports